module.exports = __webpack_public_path__ + "static/img/y1.49d2e7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y1.jpg
// module id = vOzi
// module chunks = 1